exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media only screen and (max-width: 800px) {\n.white--text.mobile-text-color[data-v-166c4d8a] {\n        color: #F5B821!important;\n}\n}\n", ""]);

// exports
